import React from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import App from "../App";
// import Error404Page from "../Error404Page";
import ActionTypes from "../common/constants/ActionTypes";

const Routes = () => {
  return (
    <Router>
      <Switch>
        <Route path={`/${ActionTypes.LOB}`} component={App} />
        <Route path={`/`} component={App} render={() => <Redirect to={`/${ActionTypes.LOB}`} />} />
      </Switch>
    </Router>
  );
};

export default Routes;
